import { ModelTranslator } from '@/types/ApiResponseTypes'
import { OrderRequestBody } from '@/types/order/OrderResponse'
import { OrderRequest, isOrderRequest } from '@/types/order/OrderType'

class orderRequestTranslator implements ModelTranslator<OrderRequest> {
  convertToModel(model: any): OrderRequestBody {
    if (isOrderRequest(model)) {
      return {
        page: model.page,
        pageSize: model.pageSize,
      }
    }
    return { page: 1, pageSize: 20 }
  }
}

export default new orderRequestTranslator()
